"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryReact = void 0;

var _basisTheoryJs = require("@basis-theory/basis-theory-js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class BasisTheoryReact extends _basisTheoryJs.BasisTheory {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "elementMap", {});
  }

  /**
   * @deprecated since v1.5.0 in favor of using {@link https://docs.basistheory.com/elements#basistheoryreact-using-refs refs}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getElement(id) {
    const element = this.elementMap[id];

    if (!element) {
      throw new Error(`Unable to find an Element with id "${id}". Please make sure there is an Element declared in the DOM with the provided id as a prop.`);
    }

    return this.elementMap[id];
  }

  indexElement(id, element) {
    this.elementMap = { ...this.elementMap,
      [id]: element
    };
  }

  disposeElement(id) {
    delete this.elementMap[id];
  }

}

exports.BasisTheoryReact = BasisTheoryReact;